/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.11.3.0 (NJsonSchema v10.4.4.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import * as moment from "moment";
export abstract class ClientBase {
    constructor(protected configuration: AuthConfig) {}

    protected async transformOptions(options: RequestInit): Promise<RequestInit> {
        if (this.configuration.token) {
            options.headers["Authorization"] = `Bearer ${this.configuration.token}`;
        }

        options.headers["pragma"] = "no-cache";
        options.headers["cache-control"] = "no-cache";
        options.headers["X-Api-Version"] = (<any>window).apiVersion;
        if (this.configuration.setAdditionalOptions) {
            this.configuration.setAdditionalOptions(options);
        }

        return options;
    }

    protected async transformResult(url: string, response: Response, processor: (response: Response) => Promise<any>): Promise<any> {
        let res = await new Promise((resolve, reject) => {
            processor(response)
                .then((r) => {
                    this.mapDatesToMoment(r);
                    resolve(r);
                })
                .catch(async (r) => {
                    let res: WebApiErrorResponse = {
                        isWebApiErrorResponse: true,
                        url: url,
                        body: <string>r.response,
                        statusCode: response.status,
                        stack: <string>r.stack,
                        headers: response.headers,
                    };

                    reject(res);
                });
        });

        return res;
    }

    protected mapDatesToMoment(obj: any) {
        if (!obj) {
            return;
        }

        if (obj instanceof Array) {
            for (let item of obj) {
                this.mapDatesToMoment(item);
            }
        }

        if (typeof obj === "object") {
            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                    if (
                        /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/.test(
                            obj[key],
                        )
                    ) {
                        obj[key] = moment(obj[key]);
                    } else {
                        this.mapDatesToMoment(obj[key]);
                    }
                }
            }
        }

        if (
            typeof obj === "string" &&
            /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/.test(
                obj,
            )
        ) {
            obj = moment(obj);
        }
    }
}

export interface IContextClient {
    /**
     * Returns info about the logged in user.
     * @param body (optional) 
     * @return Success
     */
    getContext(body?: ContextRequestModel | null | undefined): Promise<ContextModel>;
}

export class ContextClient extends ClientBase implements IContextClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Returns info about the logged in user.
     * @param body (optional) 
     * @return Success
     */
    getContext(body?: ContextRequestModel | null | undefined): Promise<ContextModel> {
        let url_ = this.baseUrl + "/api/context/get-context";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetContext(_response));
        });
    }

    protected processGetContext(response: Response): Promise<ContextModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ContextModel>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContextModel>(<any>null);
    }
}

export interface IDebugPanelClient {
    /**
     * Generate test pdf.
     * @return Success
     */
    generateTestPdf(): Promise<FileResponse>;
}

export class DebugPanelClient extends ClientBase implements IDebugPanelClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Generate test pdf.
     * @return Success
     */
    generateTestPdf(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DebugPanel/generate-test-pdf";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenerateTestPdf(_response));
        });
    }

    protected processGenerateTestPdf(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export interface IEmailClient {
    /**
     * Sends out emails that were created in the request with the given context id.
     * @return Success
     */
    sendBatch(batchId: string): Promise<void>;
}

export class EmailClient extends ClientBase implements IEmailClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Sends out emails that were created in the request with the given context id.
     * @return Success
     */
    sendBatch(batchId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Email/send-batch?";
        if (batchId === undefined || batchId === null)
            throw new Error("The parameter 'batchId' must be defined and cannot be null.");
        else
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSendBatch(_response));
        });
    }

    protected processSendBatch(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <{ [key: string]: string[]; }>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export interface ILayoutClient {
    /**
     * Get the header and the footer of the site.
     * @return Success
     */
    getSiteLayout(): Promise<Layout>;
}

export class LayoutClient extends ClientBase implements ILayoutClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get the header and the footer of the site.
     * @return Success
     */
    getSiteLayout(): Promise<Layout> {
        let url_ = this.baseUrl + "/api/Layout/SiteLayout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSiteLayout(_response));
        });
    }

    protected processGetSiteLayout(response: Response): Promise<Layout> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Layout>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Layout>(<any>null);
    }
}

export interface ILookupClient {
    /**
     * Gets all the lookups that are required for the client-side app.
     * @return Success
     */
    getPublicConfiguration(): Promise<PublicConfiguration>;
    /**
     * Gets all users for debug user dropdown menu.
     * @return Success
     */
    getAllUsers(): Promise<UserDto[]>;
    /**
     * Gets the current API version
     * @return Success
     */
    getApiVersion(): Promise<string>;
}

export class LookupClient extends ClientBase implements ILookupClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets all the lookups that are required for the client-side app.
     * @return Success
     */
    getPublicConfiguration(): Promise<PublicConfiguration> {
        let url_ = this.baseUrl + "/api/lookup/public-configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPublicConfiguration(_response));
        });
    }

    protected processGetPublicConfiguration(response: Response): Promise<PublicConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PublicConfiguration>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PublicConfiguration>(<any>null);
    }

    /**
     * Gets all users for debug user dropdown menu.
     * @return Success
     */
    getAllUsers(): Promise<UserDto[]> {
        let url_ = this.baseUrl + "/api/lookup/all-users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllUsers(_response));
        });
    }

    protected processGetAllUsers(response: Response): Promise<UserDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto[]>(<any>null);
    }

    /**
     * Gets the current API version
     * @return Success
     */
    getApiVersion(): Promise<string> {
        let url_ = this.baseUrl + "/api/lookup/api-version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetApiVersion(_response));
        });
    }

    protected processGetApiVersion(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }
}

export interface IQuestionnaireClient {
    /**
     * Get questionnaire.
     * @param questionnaireType (optional) 
     * @return Success
     */
    getQuestionnaire(questionnaireType?: string | null | undefined): Promise<QuestionnaireData>;
    /**
     * Submit questionnaire.
     * @param questionnaireType (optional) 
     * @param body (optional) 
     * @return Success
     */
    submitQuestionnaire(questionnaireType?: string | null | undefined, body?: QuestionAnswer[] | null | undefined): Promise<SubmitQuestionnaireResponse>;
}

export class QuestionnaireClient extends ClientBase implements IQuestionnaireClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get questionnaire.
     * @param questionnaireType (optional) 
     * @return Success
     */
    getQuestionnaire(questionnaireType?: string | null | undefined): Promise<QuestionnaireData> {
        let url_ = this.baseUrl + "/api/Questionnaire?";
        if (questionnaireType !== undefined && questionnaireType !== null)
            url_ += "QuestionnaireType=" + encodeURIComponent("" + questionnaireType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetQuestionnaire(_response));
        });
    }

    protected processGetQuestionnaire(response: Response): Promise<QuestionnaireData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <QuestionnaireData>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireData>(<any>null);
    }

    /**
     * Submit questionnaire.
     * @param questionnaireType (optional) 
     * @param body (optional) 
     * @return Success
     */
    submitQuestionnaire(questionnaireType?: string | null | undefined, body?: QuestionAnswer[] | null | undefined): Promise<SubmitQuestionnaireResponse> {
        let url_ = this.baseUrl + "/api/Questionnaire?";
        if (questionnaireType !== undefined && questionnaireType !== null)
            url_ += "QuestionnaireType=" + encodeURIComponent("" + questionnaireType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubmitQuestionnaire(_response));
        });
    }

    protected processSubmitQuestionnaire(response: Response): Promise<SubmitQuestionnaireResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SubmitQuestionnaireResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmitQuestionnaireResponse>(<any>null);
    }
}

export interface IQuestionnaireAnswerClient {
    /**
     * Get the details of a user's questionary answers.
     * @param answerSheetId (optional) 
     * @return Success
     */
    getUserAnswerSheetDetails(answerSheetId?: string | null | undefined): Promise<AnswerSheetDataDto>;
    /**
     * Get user's questionnaire answer history.
     * @return Success
     */
    getUserAnswerSheets(): Promise<AnswerSheetDto[]>;
    /**
     * Generate user's report in pdf and save to S3.
     * @param body (optional) 
     * @return Success
     */
    generateUserPdfReport(aSheetId: string, body?: GeneratePdfResourceParameters | null | undefined): Promise<void>;
    /**
     * Get answer sheet's pdf export download url.
     * @return Success
     */
    getExportDownloadUrl(aSheetId: string): Promise<AnswerSheetResultPdfDownload>;
}

export class QuestionnaireAnswerClient extends ClientBase implements IQuestionnaireAnswerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get the details of a user's questionary answers.
     * @param answerSheetId (optional) 
     * @return Success
     */
    getUserAnswerSheetDetails(answerSheetId?: string | null | undefined): Promise<AnswerSheetDataDto> {
        let url_ = this.baseUrl + "/api/QuestionnaireAnswer/UserAnswerSheetDetails?";
        if (answerSheetId !== undefined && answerSheetId !== null)
            url_ += "answerSheetId=" + encodeURIComponent("" + answerSheetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserAnswerSheetDetails(_response));
        });
    }

    protected processGetUserAnswerSheetDetails(response: Response): Promise<AnswerSheetDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AnswerSheetDataDto>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnswerSheetDataDto>(<any>null);
    }

    /**
     * Get user's questionnaire answer history.
     * @return Success
     */
    getUserAnswerSheets(): Promise<AnswerSheetDto[]> {
        let url_ = this.baseUrl + "/api/QuestionnaireAnswer/UserAnswerSheets";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserAnswerSheets(_response));
        });
    }

    protected processGetUserAnswerSheets(response: Response): Promise<AnswerSheetDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AnswerSheetDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnswerSheetDto[]>(<any>null);
    }

    /**
     * Generate user's report in pdf and save to S3.
     * @param body (optional) 
     * @return Success
     */
    generateUserPdfReport(aSheetId: string, body?: GeneratePdfResourceParameters | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/QuestionnaireAnswer/generate-export/{aSheetId}";
        if (aSheetId === undefined || aSheetId === null)
            throw new Error("The parameter 'aSheetId' must be defined.");
        url_ = url_.replace("{aSheetId}", encodeURIComponent("" + aSheetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenerateUserPdfReport(_response));
        });
    }

    protected processGenerateUserPdfReport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get answer sheet's pdf export download url.
     * @return Success
     */
    getExportDownloadUrl(aSheetId: string): Promise<AnswerSheetResultPdfDownload> {
        let url_ = this.baseUrl + "/api/QuestionnaireAnswer/get-download-url/{aSheetId}";
        if (aSheetId === undefined || aSheetId === null)
            throw new Error("The parameter 'aSheetId' must be defined.");
        url_ = url_.replace("{aSheetId}", encodeURIComponent("" + aSheetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetExportDownloadUrl(_response));
        });
    }

    protected processGetExportDownloadUrl(response: Response): Promise<AnswerSheetResultPdfDownload> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AnswerSheetResultPdfDownload>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnswerSheetResultPdfDownload>(<any>null);
    }
}

export interface IReportClient {
    /**
     * Reports an error happened in the client.
     * @return Success
     */
    sendClientException(body: ClientExceptionModel): Promise<void>;
    /**
     * Creates report and sends to the configured email address
     * @return Success
     */
    getMembersReport(): Promise<boolean>;
}

export class ReportClient extends ClientBase implements IReportClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Reports an error happened in the client.
     * @return Success
     */
    sendClientException(body: ClientExceptionModel): Promise<void> {
        let url_ = this.baseUrl + "/api/Report/client-exception";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSendClientException(_response));
        });
    }

    protected processSendClientException(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <{ [key: string]: string[]; }>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Creates report and sends to the configured email address
     * @return Success
     */
    getMembersReport(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Report/members-report";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMembersReport(_response));
        });
    }

    protected processGetMembersReport(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <boolean>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export interface ITrainingContentRecommendationsClient {
    /**
     * Get the recommended training contents.
     * @param questionnaireType (optional) 
     * @param taxonomyId (optional) 
     * @param mediaTypeId (optional) 
     * @param showAll (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getTrainingContentRecommendations(questionnaireType?: string | null | undefined, taxonomyId?: string | null | undefined, mediaTypeId?: string | null | undefined, showAll?: boolean | null | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined): Promise<TrainingContentResponse>;
    /**
     * Get training content filter values.
     * @return Success
     */
    getTrainingContentFilters(): Promise<TrainingContentFilters>;
}

export class TrainingContentRecommendationsClient extends ClientBase implements ITrainingContentRecommendationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get the recommended training contents.
     * @param questionnaireType (optional) 
     * @param taxonomyId (optional) 
     * @param mediaTypeId (optional) 
     * @param showAll (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getTrainingContentRecommendations(questionnaireType?: string | null | undefined, taxonomyId?: string | null | undefined, mediaTypeId?: string | null | undefined, showAll?: boolean | null | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined): Promise<TrainingContentResponse> {
        let url_ = this.baseUrl + "/api/TrainingContentRecommendations?";
        if (questionnaireType !== undefined && questionnaireType !== null)
            url_ += "QuestionnaireType=" + encodeURIComponent("" + questionnaireType) + "&";
        if (taxonomyId !== undefined && taxonomyId !== null)
            url_ += "TaxonomyId=" + encodeURIComponent("" + taxonomyId) + "&";
        if (mediaTypeId !== undefined && mediaTypeId !== null)
            url_ += "MediaTypeId=" + encodeURIComponent("" + mediaTypeId) + "&";
        if (showAll !== undefined && showAll !== null)
            url_ += "ShowAll=" + encodeURIComponent("" + showAll) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTrainingContentRecommendations(_response));
        });
    }

    protected processGetTrainingContentRecommendations(response: Response): Promise<TrainingContentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TrainingContentResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingContentResponse>(<any>null);
    }

    /**
     * Get training content filter values.
     * @return Success
     */
    getTrainingContentFilters(): Promise<TrainingContentFilters> {
        let url_ = this.baseUrl + "/api/TrainingContentRecommendations/filters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTrainingContentFilters(_response));
        });
    }

    protected processGetTrainingContentFilters(response: Response): Promise<TrainingContentFilters> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TrainingContentFilters>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingContentFilters>(<any>null);
    }
}

export interface IUserClient {
    /**
     * Creates a user if necessary, and sends an email with token to allow the user to log in.
     * @param redirectUrl (optional) 
     * @param pendingAnswerSheetId (optional) 
     * @return Success
     */
    loginByEmail(email: string, redirectUrl?: string | null | undefined, pendingAnswerSheetId?: string | null | undefined): Promise<boolean>;
    /**
     * Generates new token for the logged-in user.
     * @return Success
     */
    refreshToken(body: RefreshTokenRequest): Promise<TokenResponse>;
    /**
     * Gets user information of the currently logged-in user.
     * @return Success
     */
    getInfo(): Promise<UserInfo>;
    /**
     * Wipes out the user from the application.
     * @return Success
     */
    wipeOut(userId: string): Promise<void>;
    /**
     * Logs an entry about visiting pages with user information.
     * @return Success
     */
    logAuditTrail(body: AuditTrailLogModel): Promise<void>;
    /**
     * Gets an access token for a given user.
     * @return Success
     */
    getToken(userId: string): Promise<TokenResponse>;
    /**
     * Log out a given user.
     * @param userId (optional) 
     * @return Success
     */
    logout(userId?: string | null | undefined): Promise<void>;
}

export class UserClient extends ClientBase implements IUserClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Creates a user if necessary, and sends an email with token to allow the user to log in.
     * @param redirectUrl (optional) 
     * @param pendingAnswerSheetId (optional) 
     * @return Success
     */
    loginByEmail(email: string, redirectUrl?: string | null | undefined, pendingAnswerSheetId?: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/User/login-by-email?";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (redirectUrl !== undefined && redirectUrl !== null)
            url_ += "RedirectUrl=" + encodeURIComponent("" + redirectUrl) + "&";
        if (pendingAnswerSheetId !== undefined && pendingAnswerSheetId !== null)
            url_ += "PendingAnswerSheetId=" + encodeURIComponent("" + pendingAnswerSheetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoginByEmail(_response));
        });
    }

    protected processLoginByEmail(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <boolean>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Generates new token for the logged-in user.
     * @return Success
     */
    refreshToken(body: RefreshTokenRequest): Promise<TokenResponse> {
        let url_ = this.baseUrl + "/api/User/refresh-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRefreshToken(_response));
        });
    }

    protected processRefreshToken(response: Response): Promise<TokenResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TokenResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TokenResponse>(<any>null);
    }

    /**
     * Gets user information of the currently logged-in user.
     * @return Success
     */
    getInfo(): Promise<UserInfo> {
        let url_ = this.baseUrl + "/api/User/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetInfo(_response));
        });
    }

    protected processGetInfo(response: Response): Promise<UserInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserInfo>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserInfo>(<any>null);
    }

    /**
     * Wipes out the user from the application.
     * @return Success
     */
    wipeOut(userId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/User/wipe-out?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processWipeOut(_response));
        });
    }

    protected processWipeOut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Logs an entry about visiting pages with user information.
     * @return Success
     */
    logAuditTrail(body: AuditTrailLogModel): Promise<void> {
        let url_ = this.baseUrl + "/api/User/log-audit-trail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLogAuditTrail(_response));
        });
    }

    protected processLogAuditTrail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Gets an access token for a given user.
     * @return Success
     */
    getToken(userId: string): Promise<TokenResponse> {
        let url_ = this.baseUrl + "/api/User/get-token/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetToken(_response));
        });
    }

    protected processGetToken(response: Response): Promise<TokenResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TokenResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TokenResponse>(<any>null);
    }

    /**
     * Log out a given user.
     * @param userId (optional) 
     * @return Success
     */
    logout(userId?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/User/logout?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLogout(_response));
        });
    }

    protected processLogout(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export interface AnswerSheetDataDto {
    taxonomyTexts?: AnswerSheetTaxonomyText[] | null;
    results?: AnswerSheetResultDataDto[] | null;
    debugPanelInfo?: AnswerSheetResultDebugPanel[] | null;
    pdfDownload?: AnswerSheetResultPdfDownload | null;
}

export interface AnswerSheetDto {
    answerSheetCreated?: moment.Moment | null;
    answerSheetId?: string | null;
}

export interface AnswerSheetResultDataDto {
    taxonomyId?: string | null;
    taxonomySequentialId?: number | null;
    taxonomyName?: string | null;
    score?: number | null;
}

export interface AnswerSheetResultDebugPanel {
    taxonomyId?: string | null;
    taxonomy?: string | null;
    score?: number | null;
    scoreBand?: string | null;
    correctAnswersCount?: number | null;
    allAnswersCount?: number | null;
    paragraphOrder?: number | null;
}

export interface AnswerSheetResultPdfDownload {
    downloadLink?: string | null;
    fileSize?: number | null;
}

export interface AnswerSheetTaxonomyText {
    taxonomyId?: string | null;
    taxonomy?: string | null;
    text?: string | null;
    scoreBand?: string | null;
}

export interface AuditTrailLogModel {
    screenName: string;
    url: string;
}

export enum AuthorizableActions {
    UseDebugFunctions = <any>"UseDebugFunctions",
}

export interface ClientExceptionModel {
    message: string;
    url: string;
    userId?: string | null;
}

export interface ContextModel {
    authorizedActions?: AuthorizableActions[] | null;
    request?: ContextRequestModel | null;
    userId?: string | null;
}

export interface ContextRequestModel {
    userId?: string | null;
}

export interface GeneratePdfResourceParameters {
    questionnaireType?: string | null;
}

export interface Layout {
    headerHtmlEncode?: string | null;
    footerHtmlEncode?: string | null;
    styleURL?: string | null;
    scriptUrl?: string | null;
    scriptPluginsURL?: string | null;
}

export interface ProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
}

export interface PublicConfiguration {
    instanceType: string;
    instanceOwner: string;
    instanceUrl: string;
    appName: string;
    showErrorDetails: boolean;
    showUserDropdown: boolean;
    isLoginPageEnabled: boolean;
    isDebugPanelEnabled: boolean;
    isOpenIdLoginEnabled: boolean;
    openIdLoginUrl: string;
    openIdLogoutUrl: string;
    exportPdfRefreshIntervalInSec: number;
    googleAnalyticsId?: string | null;
    googleTagManagerId?: string | null;
    hotjarId?: number | null;
    feedbackEmail: string;
}

export interface QuestionAnswer {
    taxonomyId: string;
    questionId: string;
    questionVariantId: string;
    answer?: boolean | null;
}

export interface QuestionDebugData {
    correctAnswer?: boolean | null;
    taxonomyName?: string | null;
    weight?: number | null;
}

export interface QuestionItem {
    taxonomyId?: string | null;
    questionId?: string | null;
    questionVariantId?: string | null;
    text?: string | null;
    answer?: boolean | null;
    debugDetails?: QuestionDebugData | null;
}

export interface QuestionnaireData {
    title?: string | null;
    instructions?: string | null;
    questions?: QuestionItem[] | null;
}

export interface RefreshTokenRequest {
    refreshToken: string;
}

export interface SelectOption {
    value?: string | null;
    name?: string | null;
}

export interface SubmitQuestionnaireResponse {
    pendingAnswerSheetId?: string | null;
}

export interface TokenResponse {
    token?: string | null;
    refreshToken?: string | null;
}

export interface TrainingContent {
    id?: string | null;
    url?: string | null;
    title?: string | null;
    ingress?: string | null;
    thumbnailUrl?: string | null;
    taxonomyName?: string | null;
    duration?: number | null;
    type?: string | null;
}

export interface TrainingContentFilters {
    taxonomies?: SelectOption[] | null;
    mediaTypes?: SelectOption[] | null;
}

export interface TrainingContentResponse {
    trainingContents?: TrainingContent[] | null;
    currentPage?: number | null;
    hasNextPage?: boolean | null;
}

export interface UserDto {
    id?: string | null;
    fullName?: string | null;
}

export interface UserInfo {
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    userId?: string | null;
    memberStatus?: UserMemberStatus | null;
    hasSubmittedQuestionnaire?: boolean | null;
}

export enum UserMemberStatus {
    Member = <any>"Member",
    NonMember = <any>"NonMember",
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new SwaggerException(message, status, response, headers, result);
}

export interface AuthConfig {
    token: string;
    refreshToken: string;
    setAdditionalOptions?: (options: RequestInit) => void;
}

export interface WebApiErrorResponse {
    url: string;
    statusCode: number;
    body: string;
    isWebApiErrorResponse: boolean;
    stack: string;
    headers: Headers;
}